export function addSearchParams(urlString: string, params: Record<string, string>) {
  if (Object.entries(params).length === 0) {
    return urlString;
  }

  const match = urlString.match(/^(.*)\?(.*)$/);
  const originalParameterString = match?.[2];
  const urlUntilQuestionMark = match?.[1] ?? urlString;
  const originalSearchParams = new URLSearchParams(originalParameterString);

  for (const [key, value] of Object.entries(params)) {
    originalSearchParams.set(key, value);
  }
  return urlUntilQuestionMark + '?' + originalSearchParams.toString();
}
